function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var saito = require('./../../lib/saito/saito');
var MixinModule = require('./lib/mixinmodule');
var ModTemplate = require('../../lib/templates/modtemplate');
var fetch = require('node-fetch');
var axios = require('axios');
var Decimal = require('decimal.js');
var JSON = require('json-bigint');
var PeerService = require('saito-js/lib/peer_service')["default"];
var _require = require('@mixin.dev/mixin-node-sdk'),
  MixinApi = _require.MixinApi,
  getED25519KeyPair = _require.getED25519KeyPair,
  signEd25519PIN = _require.signEd25519PIN,
  base64RawURLEncode = _require.base64RawURLEncode,
  base64RawURLDecode = _require.base64RawURLDecode,
  getTipPinUpdateMsg = _require.getTipPinUpdateMsg,
  MixinCashier = _require.MixinCashier,
  buildSafeTransactionRecipient = _require.buildSafeTransactionRecipient,
  getUnspentOutputsForRecipients = _require.getUnspentOutputsForRecipients,
  buildSafeTransaction = _require.buildSafeTransaction,
  encodeSafeTransaction = _require.encodeSafeTransaction,
  signSafeTransaction = _require.signSafeTransaction,
  blake3Hash = _require.blake3Hash;
var _require2 = require('uuid'),
  v4 = _require2.v4;
function createMixinCredentials() {
  var account = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keystore = {
    app_id: account.user_id,
    session_id: account.session_id,
    pin_token_base64: account.tip_key_base64 || account.pin_token_base64,
    session_private_key: account.session_seed || account.session_private_key
  };
  var spend_private_key = account.spend_private_key;
  var missing = [];
  for (var _i = 0, _Object$entries = Object.entries(_objectSpread(_objectSpread({}, keystore), {}, {
      spend_private_key: spend_private_key
    })); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      name = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (!value) {
      missing.push(name);
    }
  }
  if (missing.length) {
    throw new Error("Mixin account configuration is incomplete (missing: ".concat(missing.join(', '), ")"));
  }
  return {
    keystore: keystore,
    spend_private_key: spend_private_key,
    user_id: keystore.app_id
  };
}
function createMixinMemo() {
  var memo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (Buffer.isBuffer(memo)) {
    return memo;
  }
  return Buffer.from(String(memo), 'utf8');
}
function calculatePendingBalance(balance) {
  var pending = new Decimal(balance);
  for (var _len = arguments.length, deductions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    deductions[_key - 1] = arguments[_key];
  }
  for (var _i2 = 0, _deductions = deductions; _i2 < _deductions.length; _i2++) {
    var deduction = _deductions[_i2];
    pending = pending.minus(deduction);
  }
  return Number(pending.toFixed(8));
}
function selectWithdrawalFee(feeResponse, assetId, chainAssetId) {
  var _ref;
  var fees = Array.isArray(feeResponse) ? feeResponse : feeResponse ? [feeResponse] : [];
  var assetFee = fees.find(function (fee) {
    return fee.asset_id === assetId;
  });
  var chainFee = fees.find(function (fee) {
    return fee.asset_id === chainAssetId;
  });
  return (_ref = assetFee !== null && assetFee !== void 0 ? assetFee : chainFee) !== null && _ref !== void 0 ? _ref : fees.length === 1 ? fees[0] : null;
}
function formatMixinError(err) {
  var _err$response;
  var apiError = err === null || err === void 0 || (_err$response = err.response) === null || _err$response === void 0 || (_err$response = _err$response.data) === null || _err$response === void 0 ? void 0 : _err$response.error;
  if (apiError !== null && apiError !== void 0 && apiError.description || apiError !== null && apiError !== void 0 && apiError.code) {
    return [apiError.code, apiError.description].filter(Boolean).join(': ');
  }
  if (err instanceof Error) {
    return err.message;
  }
  if (typeof err === 'string') {
    return err;
  }
  try {
    var serialized = JSON.stringify(err);
    return serialized === undefined ? String(err) : serialized;
  } catch (jsonError) {
    return String(err);
  }
}

//
// Mixin Module
//
// Mixin is an infrastructure / API provider for multiple cryptocurrency wallets. Thie Saito
// modules provides integration with their backend API to various Saito modules, permitting
// users to store and use Mixin-held cryptocurrencies on the network as with other crypto-
// modules like DOT.
//
// In addition to integrating with the Saito Wallet. This module also offers functionality
// that allows Saito nodes to collect payment in non-SAITO cryptocurrencies, by supporting
// their ability to automatically collect non-SAITO cryptos and exchange them for SAITO in
// real-time. This powers the "buy with other crypto" functionality in the Saito Store and
// in the "buysaito" app.
//
var Mixin = /*#__PURE__*/function (_ModTemplate) {
  function Mixin(app) {
    var _this;
    _classCallCheck(this, Mixin);
    _this = _callSuper(this, Mixin, [app]);
    _this.name = 'Mixin';
    _this.slug = 'mixin';
    _this.appname = 'Mixin';
    _this.description = 'Adding support for Web3 Crypto transfers on Saito';
    _this.categories = 'Finance Utilities';
    _this.icon = 'fas fa-wallet';
    _this["class"] = 'utility';
    _this.status = 'prod';

    //
    // reference for dynamic modules
    //
    _this.MixinModule = MixinModule;

    //
    // wallets will contain
    //
    _this.mixin = {};
    // this.mixin.user_id = '';
    // this.mixin.session_id = '';
    // this.mixin.session_seed = '';
    // this.mixin.full_name = '';
    // this.mixin.tip_key_base64 = '';
    // this.mixin.spend_private_key = '';
    // this.mixin.spend_public_key = '';

    _this.mixin_peer = null;
    _this.bot = null;
    _this.account_created = 0;
    _this.account_creation_promise = null;
    _this.crypto_mods = [];
    return _this;
  }

  //
  // returnServices
  //
  // Mixin service allows nodes and browsers which connect to this device to create
  // wallets using the Mixin API key of this node. This service is necessary since
  // requests for account creation must be linked to an existing API-key, and fee-free
  // transfers within Saito are possible between wallets that were created with the
  // same API-key.
  //
  _inherits(Mixin, _ModTemplate);
  return _createClass(Mixin, [{
    key: "returnServices",
    value: function returnServices() {
      this.services = [];
      if (this.bot) {
        this.services.push(new PeerService(null, 'mixin'));
      }
      return this.services;
    }

    //
    // initialize
    //
    // the information needed to access Mixin through its API requires data that is
    // stored in the ENV of the server that is running Saito. On initialization we
    // fetch this information and put it into the "this.bot" variable.
    //
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var m, keystore;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _superPropGet(Mixin, "initialize", this, 3)([app]);
            case 1:
              _context.n = 2;
              return this.load();
            case 2:
              if (!app.BROWSER) {
                if (!this.bot) {
                  m = null;
                  try {
                    if (typeof process.env.MIXIN != 'undefined') {
                      m = JSON.parse(process.env.MIXIN);
                    }
                  } catch (err) {}
                  if (m) {
                    keystore = {
                      app_id: m.app_id,
                      session_id: m.session_id,
                      server_public_key: m.server_public_key,
                      session_private_key: m.session_private_key
                    };
                    this.bot = MixinApi({
                      keystore: keystore
                    });
                  }
                }
              }
              this.installCryptos();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }() //
    // off-chain requests
    //
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
        var tx,
          peer,
          mycallback,
          message,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              tx = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : null;
              peer = _args2.length > 2 ? _args2[2] : undefined;
              mycallback = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : null;
              if (!(tx == null)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, 0);
            case 1:
              message = tx.returnMessage(); //
              // create account
              //
              if (!(message.request === 'mixin create account')) {
                _context2.n = 3;
                break;
              }
              _context2.n = 2;
              return this.receiveCreateAccountTransaction(app, tx, peer, mycallback);
            case 2:
              return _context2.a(2, _context2.v);
            case 3:
              if (!(message.request === 'mixin save new deposit address')) {
                _context2.n = 5;
                break;
              }
              _context2.n = 4;
              return this.receiveSaveUserTransaction(app, tx, peer, mycallback);
            case 4:
              return _context2.a(2, _context2.v);
            case 5:
              if (!(message.request === 'mixin fetch user')) {
                _context2.n = 7;
                break;
              }
              _context2.n = 6;
              return this.receiveFetchUserTransaction(app, tx, peer, mycallback);
            case 6:
              return _context2.a(2, 1);
            case 7:
              if (!(message.request === 'mixin account backup')) {
                _context2.n = 9;
                break;
              }
              _context2.n = 8;
              return this.receiveMixinBackupAccountRequest(message.data.account_hash, peer.publicKey, false);
            case 8:
              if (mycallback) {
                mycallback();
              }
              return _context2.a(2, 1);
            case 9:
              return _context2.a(2, _superPropGet(Mixin, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee2, this);
      }));
      function handlePeerTransaction(_x2) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "respondTo",
    value: function respondTo() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 ? arguments[1] : undefined;
      if (type == 'crypto-logo') {
        var ticker = obj.ticker;
        var _iterator = _createForOfIteratorHelper(this.crypto_mods),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var cm = _step.value;
            if (ticker == cm.ticker) {
              if (cm.respondTo('crypto-logo', obj)) {
                return cm.respondTo('crypto-logo', obj);
              }
              var rtn_obj = {};
              if (cm.icon_url) {
                rtn_obj.img = cm.icon_url;
                rtn_obj.alt_img = "/".concat(ticker.toLowerCase(), "/img/logo.png");
              } else {
                rtn_obj.img = "/".concat(ticker.toLowerCase(), "/img/logo.png");
              }
              if (cm.chain_id !== cm.asset_id) {
                for (var i = 0; i < this.crypto_mods.length; i++) {
                  if (this.crypto_mods[i].asset_id == cm.chain_id) {
                    rtn_obj.sub_logo = "/".concat(this.crypto_mods[i].ticker.toLowerCase(), "/img/logo.png");
                  }
                }
              }
              return rtn_obj;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return null;
    }
    //
    // installCryptos
    //
    // this checks all modules that extend from the MixinModule template in the /lib
    // directory. this ensures those modules are initialized and fetches the balance
    // for any which are activated as the default web3 crypto.
    //
  }, {
    key: "installCryptos",
    value: function installCryptos() {
      var _this2 = this;
      var mixin_self = this;
      var rtModules = this.app.modules.respondTo('mixin-crypto');
      var _loop = function _loop() {
        var crypto_module = new MixinModule(_this2.app, mixin_self, rtModules[i].ticker, rtModules[i].asset_id, rtModules[i].chain_id);

        //
        // Use the module's returnBalance function if provided
        //
        if (rtModules[i].returnBalance) {
          crypto_module.returnBalance = rtModules[i].returnBalance;
        }
        if (_this2.app.BROWSER) {
          if (!_this2.app.browser.returnURLParameter('withdraw')) {
            if (rtModules[i].name !== rtModules[i].ticker) {
              console.warn('Installing a ghost crypto module: ', rtModules[i].name, rtModules[i].ticker);
              crypto_module.hide_me = true;
            }
          }
        }
        _this2.crypto_mods.push(crypto_module);
        _this2.app.modules.mods.push(crypto_module);
        setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                if (!(typeof (crypto_module === null || crypto_module === void 0 ? void 0 : crypto_module.returnMixinNetworkInfo) === 'function')) {
                  _context3.n = 1;
                  break;
                }
                _context3.n = 1;
                return crypto_module.returnMixinNetworkInfo();
              case 1:
                _context3.n = 2;
                return crypto_module.installModule(mixin_self.app);
              case 2:
                if (!mixin_self.account_created) {
                  _context3.n = 3;
                  break;
                }
                if (!(crypto_module.isActivated() || crypto_module.address)) {
                  _context3.n = 3;
                  break;
                }
                _context3.n = 3;
                return crypto_module.activate();
              case 3:
                return _context3.a(2);
            }
          }, _callee3);
        })), 250);
      };
      for (var i = 0; i < rtModules.length; i++) {
        _loop();
      }
    }
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app, peer) {
        var _this3 = this;
        var service,
          input,
          account_hash,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              service = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
              if (service.service === 'mixin') {
                console.info('Mixin Module: API online!');
                this.mixin_peer = peer;
                if (this.mixin.user_id) {
                  if (!this.mixin.backed_up) {
                    console.info('Need to back up my mixin');
                    input = Buffer.from(JSON.stringify(this.mixin), 'utf8');
                    account_hash = this.app.crypto.encryptWithPublicKey(input, this.publicKey).toString('base64');
                    this.app.network.sendRequestAsTransaction('mixin account backup', {
                      account_hash: account_hash
                    }, function () {
                      _this3.mixin.backed_up = true;
                      _this3.save();
                    }, peer.publicKey);
                  }
                }
              }
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function onPeerServiceUp(_x3, _x4) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }() //
    // The following functions are used by the /lib/mixinmodule.js class that is the
    // parent module for any Saito Module that implements a Mixin ticker. Please be careful
    // when changing names or updating function contents for these functions...
    //
    // Core MixinModule API:
    // ---------------------
    // * createAccount()
    // * createDepositAddress()
    // fetchSafeUtxoBalance()
    // fetchUtxo()
    // fetchSafeSnapshots()
    // fetchPendingDeposits()
    // returnMixinNetworkInfo()
    // returnWithdrawalFee()
    // sendInNetworkTransferRequest()
    // sendExternalNetworkTransferRequest()
    // sendFetchUserTransaction()
    // ---------------------
    //
  }, {
    key: "createAccount",
    value: function () {
      var _createAccount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this4 = this;
        var callback,
          force_new,
          result,
          _createAccount2,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              callback = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : null;
              force_new = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
              if (!(this.account_created && !force_new)) {
                _context6.n = 1;
                break;
              }
              console.warn('You already have a Mixin Account created...');
              result = {
                keys: this.mixin,
                existing: true
              };
              _context6.n = 9;
              break;
            case 1:
              if (!(!force_new && this.account_creation_promise)) {
                _context6.n = 3;
                break;
              }
              _context6.n = 2;
              return this.account_creation_promise;
            case 2:
              result = _context6.v;
              _context6.n = 9;
              break;
            case 3:
              _createAccount2 = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
                  var _response;
                  var privateKey, response, _response2, error, res, encrypted, decrypted, _error, _t;
                  return _regenerator().w(function (_context5) {
                    while (1) switch (_context5.p = _context5.n) {
                      case 0:
                        _context5.n = 1;
                        return _this4.app.wallet.getPrivateKey();
                      case 1:
                        privateKey = _context5.v;
                        if (!_this4.mixin_peer) {
                          _context5.n = 3;
                          break;
                        }
                        console.log('Request remote node to create Mixin User Account', _this4.mixin_peer.publicKey);
                        _context5.n = 2;
                        return new Promise(function (resolve) {
                          var settled = false;
                          var finish = function finish(res) {
                            if (!settled) {
                              settled = true;
                              clearTimeout(timeout);
                              resolve(res);
                            }
                            return res;
                          };
                          var timeout = setTimeout(function () {
                            return finish({
                              err: 'Mixin account service timed out'
                            });
                          }, 30000);
                          try {
                            Promise.resolve(_this4.sendCreateAccountTransaction(finish, force_new))["catch"](function (err) {
                              return finish({
                                err: formatMixinError(err)
                              });
                            });
                          } catch (err) {
                            finish({
                              err: formatMixinError(err)
                            });
                          }
                        });
                      case 2:
                        response = _context5.v;
                        _context5.n = 6;
                        break;
                      case 3:
                        if (!_this4.app.BROWSER) {
                          _context5.n = 4;
                          break;
                        }
                        response = {
                          err: 'Mixin account service is unavailable'
                        };
                        _context5.n = 6;
                        break;
                      case 4:
                        console.log('==> Create Mixin User Account on Same Node as API Keys');
                        _context5.n = 5;
                        return _this4.createMixinUserAccount(_this4.publicKey, null, force_new);
                      case 5:
                        response = _context5.v;
                      case 6:
                        if (!(_typeof(response) !== 'object' || !((_response = response) !== null && _response !== void 0 && _response.res))) {
                          _context5.n = 7;
                          break;
                        }
                        error = ((_response2 = response) === null || _response2 === void 0 ? void 0 : _response2.err) || 'Mixin account service returned no account';
                        console.error('Mixin Account Error:', error);
                        return _context5.a(2, {
                          err: error
                        });
                      case 7:
                        _context5.p = 7;
                        res = _objectSpread({}, response);
                        encrypted = Buffer.from(res.res, 'base64');
                        decrypted = _this4.app.crypto.decryptWithPrivateKey(encrypted, privateKey);
                        res.keys = JSON.parse(decrypted.toString('utf8'));
                        if (res.restored) {
                          console.log('Successfully Restored Mixin Account!');
                        } else {
                          console.log('Successfully Created Mixin Account!');
                        }

                        // Skip save step if we are creating multiple accounts on the same public key.
                        if (!force_new) {
                          _this4.mixin = res.keys;
                          _this4.account_created = 1;
                          _this4.save();
                        }
                        return _context5.a(2, res);
                      case 8:
                        _context5.p = 8;
                        _t = _context5.v;
                        _error = "Unable to decrypt Mixin account: ".concat(formatMixinError(_t));
                        console.error(_error);
                        return _context5.a(2, {
                          err: _error
                        });
                    }
                  }, _callee5, null, [[7, 8]]);
                }));
                return function _createAccount2() {
                  return _ref3.apply(this, arguments);
                };
              }();
              if (!force_new) {
                _context6.n = 5;
                break;
              }
              _context6.n = 4;
              return _createAccount2();
            case 4:
              result = _context6.v;
              _context6.n = 9;
              break;
            case 5:
              this.account_creation_promise = _createAccount2();
              _context6.p = 6;
              _context6.n = 7;
              return this.account_creation_promise;
            case 7:
              result = _context6.v;
            case 8:
              _context6.p = 8;
              this.account_creation_promise = null;
              return _context6.f(8);
            case 9:
              if (!callback) {
                _context6.n = 10;
                break;
              }
              _context6.n = 10;
              return callback(result);
            case 10:
              return _context6.a(2, result);
          }
        }, _callee6, this, [[6,, 8, 9]]);
      }));
      function createAccount() {
        return _createAccount.apply(this, arguments);
      }
      return createAccount;
    }()
  }, {
    key: "sendCreateAccountTransaction",
    value: function sendCreateAccountTransaction() {
      var _mixin_self$mixin_pee;
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var force_new = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var mixin_self = this;
      var data = {
        force_new: force_new
      };
      return mixin_self.app.network.sendRequestAsTransaction('mixin create account', data, callback, (_mixin_self$mixin_pee = mixin_self.mixin_peer) === null || _mixin_self$mixin_pee === void 0 ? void 0 : _mixin_self$mixin_pee.publicKey);
    }
  }, {
    key: "receiveCreateAccountTransaction",
    value: function receiveCreateAccountTransaction(app, tx, peer, callback) {
      var _txmsg$data;
      var pkey = tx.from[0].publicKey;
      var txmsg = tx.returnMessage();
      return this.createMixinUserAccount(pkey, callback, (_txmsg$data = txmsg.data) === null || _txmsg$data === void 0 ? void 0 : _txmsg$data.force_new);
    }
  }, {
    key: "createMixinUserAccount",
    value: function () {
      var _createMixinUserAccount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(pkey, callback) {
        var force_new,
          rtn_obj,
          success,
          user_id,
          db_results,
          _getED25519KeyPair,
          sessionSeed,
          sessionPublicKey,
          session_private_key,
          user,
          userClient,
          _getED25519KeyPair2,
          spendPublicKey,
          spendPrivateKey,
          spend_private_key,
          account,
          buf,
          encrypted_data,
          _args7 = arguments,
          _t2;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              force_new = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : false;
              // Check if account is already created and in DB
              rtn_obj = {};
              success = false;
              user_id = "Saito User ".concat(pkey);
              if (force_new) {
                _context7.n = 2;
                break;
              }
              _context7.n = 1;
              return this.restoreMixinAccount(pkey);
            case 1:
              db_results = _context7.v;
              if ((db_results === null || db_results === void 0 ? void 0 : db_results.length) > 0) {
                // default to the most recent (if there is more than 1)
                rtn_obj.res = db_results.pop().account_hash;
                rtn_obj.restored = true;
                success = true;
              }
              _context7.n = 3;
              break;
            case 2:
              user_id = "".concat(pkey, "_").concat(force_new.toString().padStart(3, '0'));
            case 3:
              if (success) {
                _context7.n = 13;
                break;
              }
              if (!this.bot) {
                _context7.n = 12;
                break;
              }
              _context7.p = 4;
              _getED25519KeyPair = getED25519KeyPair(), sessionSeed = _getED25519KeyPair.seed, sessionPublicKey = _getED25519KeyPair.publicKey;
              session_private_key = sessionSeed.toString('hex');
              _context7.n = 5;
              return this.bot.user.createBareUser(user_id, base64RawURLEncode(sessionPublicKey));
            case 5:
              user = _context7.v;
              console.log('user //', user.user_id);

              // update/create first tipPin
              userClient = MixinApi({
                keystore: {
                  app_id: user.user_id,
                  session_id: user.session_id,
                  pin_token_base64: user.pin_token_base64,
                  session_private_key: session_private_key
                }
              });
              _getED25519KeyPair2 = getED25519KeyPair(), spendPublicKey = _getED25519KeyPair2.publicKey, spendPrivateKey = _getED25519KeyPair2.seed;
              spend_private_key = spendPrivateKey.toString('hex');
              _context7.n = 6;
              return userClient.pin.updateTipPin('', spendPublicKey.toString('hex'), user.tip_counter + 1);
            case 6:
              console.log('update pin //');
              _context7.n = 7;
              return userClient.pin.verifyTipPin(spendPrivateKey);
            case 7:
              console.log('verify pin //');
              _context7.n = 8;
              return userClient.safe.register(user.user_id, spend_private_key, spendPrivateKey);
            case 8:
              account = _context7.v;
              console.log('safe account ///', account.user_id, account.has_safe);
              buf = Buffer.from(JSON.stringify({
                user_id: account.user_id,
                full_name: account.full_name,
                session_id: account.session_id,
                tip_key_base64: account.tip_key_base64,
                spend_private_key: spend_private_key,
                spend_public_key: spendPublicKey.toString('hex'),
                session_seed: session_private_key,
                backed_up: true
              }), 'utf8');
              encrypted_data = this.app.crypto.encryptWithPublicKey(buf, pkey).toString('base64');
              rtn_obj.res = encrypted_data;

              // Skip save step if we are creating multiple accounts on the same public key
              if (force_new) {
                _context7.n = 9;
                break;
              }
              _context7.n = 9;
              return this.backupMixinAccount(encrypted_data, pkey);
            case 9:
              _context7.n = 11;
              break;
            case 10:
              _context7.p = 10;
              _t2 = _context7.v;
              console.error('Mixin Create Account Error', _t2);
              Object.assign(rtn_obj, {
                err: 'Mixin create account error'
              });
            case 11:
              _context7.n = 13;
              break;
            case 12:
              Object.assign(rtn_obj, {
                err: 'Cannot process Mixin account request for peer'
              });
            case 13:
              if (!callback) {
                _context7.n = 14;
                break;
              }
              return _context7.a(2, callback(rtn_obj));
            case 14:
              return _context7.a(2, rtn_obj);
            case 15:
              return _context7.a(2);
          }
        }, _callee7, this, [[4, 10]]);
      }));
      function createMixinUserAccount(_x5, _x6) {
        return _createMixinUserAccount.apply(this, arguments);
      }
      return createMixinUserAccount;
    }()
  }, {
    key: "createDepositAddress",
    value: function () {
      var _createDepositAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(asset_id, chain_id) {
        var alt_keys,
          _address$,
          account,
          _createMixinCredentia,
          keystore,
          user,
          address,
          destination,
          i,
          _this$mixin_peer,
          _args8 = arguments,
          _t3;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              alt_keys = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : null;
              if (chain_id) {
                _context8.n = 1;
                break;
              }
              console.error('ERROR: Cannot create Mixin deposit address without a chain ID');
              return _context8.a(2, false);
            case 1:
              _context8.p = 1;
              account = alt_keys || this.mixin;
              _createMixinCredentia = createMixinCredentials(account), keystore = _createMixinCredentia.keystore;
              user = MixinApi({
                keystore: keystore
              });
              _context8.n = 2;
              return user.safe.createDeposit(chain_id);
            case 2:
              address = _context8.v;
              destination = address === null || address === void 0 || (_address$ = address[0]) === null || _address$ === void 0 ? void 0 : _address$.destination;
              console.log('New MIXIN deposit address:', address);
              if (destination) {
                _context8.n = 3;
                break;
              }
              console.error('ERROR: Mixin error create deposit address: Deposit Address undefined!');
              return _context8.a(2, false);
            case 3:
              if (!alt_keys) {
                for (i = 0; i < this.crypto_mods.length; i++) {
                  if (this.crypto_mods[i].asset_id === asset_id) {
                    this.crypto_mods[i].address = destination;
                    this.crypto_mods[i].save();
                    if (this.app.BROWSER) {
                      this.app.network.sendRequestAsTransaction('mixin save new deposit address', {
                        user_id: this.mixin.user_id,
                        asset_id: asset_id,
                        address: destination,
                        publickey: this.publicKey
                      }, function (res) {
                        console.log('Callback for sendSaveUserTransaction request: ', res);
                      }, (_this$mixin_peer = this.mixin_peer) === null || _this$mixin_peer === void 0 ? void 0 : _this$mixin_peer.publicKey);
                    }
                  }
                }
              }
              return _context8.a(2, destination);
            case 4:
              _context8.p = 4;
              _t3 = _context8.v;
              console.error('ERROR: Mixin error create deposit address: ' + formatMixinError(_t3));
              return _context8.a(2, false);
          }
        }, _callee8, this, [[1, 4]]);
      }));
      function createDepositAddress(_x7, _x8) {
        return _createDepositAddress.apply(this, arguments);
      }
      return createDepositAddress;
    }()
  }, {
    key: "fetchSafeUtxoBalance",
    value: function () {
      var _fetchSafeUtxoBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(asset_id) {
        var user, utxo, _t4;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.p = 0;
              user = MixinApi({
                keystore: {
                  app_id: this.mixin.user_id,
                  session_id: this.mixin.session_id,
                  pin_token_base64: this.mixin.tip_key_base64,
                  session_private_key: this.mixin.session_seed
                }
              });
              _context9.n = 1;
              return user.utxo.safeAssetBalance({
                members: [this.mixin.user_id],
                threshold: 1,
                asset: asset_id
              });
            case 1:
              utxo = _context9.v;
              return _context9.a(2, utxo);
            case 2:
              _context9.p = 2;
              _t4 = _context9.v;
              console.error('ERROR: Mixin error fetch safe utxo: ' + _t4);
              return _context9.a(2, false);
          }
        }, _callee9, this, [[0, 2]]);
      }));
      function fetchSafeUtxoBalance(_x9) {
        return _fetchSafeUtxoBalance.apply(this, arguments);
      }
      return fetchSafeUtxoBalance;
    }()
    /***
     *  Returns a chronological Array of Objects with the format
     *
     * snapshot_id: "6049b6c2-3f9e-3627-b671-c81f4f6a88fa"
     * user_id: "95b8a0a4-1032-33e7-9154-5f48ebe00a14"
     * opponent_id: "dac46e33-fdd2-3453-b77a-73ffadba1ff1"
     * transaction_hash: "1db6dc53df33bfc7dd38afa86eb83454b5b71bc178da653431ddc9af025a7487"
     * asset_id: "43d61dcd-e413-450d-80b8-101d5e903357"
     * kernel_asset_id: "8dd50817c082cdcdd6f167514928767a4b52426997bd6d4930eca101c5ff8a27"
     * amount: "0.005"
     * memo: "746573742d6d656d6f"
     * request_id: "bfb05bb6-03e5-4b5c-a7ab-2ad5a4ed56a7"
     * created_at: "2025-08-25T03:23:17.657426Z"
     * level: 11
     * type: "snapshot"
     * inscription_hash: "INSCRIPTION-HASH"
     * deposit: { "deposit_hash": "DEPOSIT-HASH", "deposit_index": 1,
            "sender": "SOME-STRING", "destination": "DEPOSIT-DESTINATION", "tag": "DEPOSIT-TAG" }
     * withdrawal: { "withdrawal_hash": "WITHDRAWAL-HASH", "receiver": "SOME-STRING"  }
     *
     */
  }, {
    key: "fetchSafeSnapshots",
    value: function () {
      var _fetchSafeSnapshots = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(asset_id) {
        var created_at,
          callback,
          user,
          offset,
          snapshots,
          _args0 = arguments,
          _t5;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              created_at = _args0.length > 1 && _args0[1] !== undefined ? _args0[1] : 0;
              callback = _args0.length > 2 && _args0[2] !== undefined ? _args0[2] : null;
              _context0.p = 1;
              user = MixinApi({
                keystore: {
                  app_id: this.mixin.user_id,
                  session_id: this.mixin.session_id,
                  pin_token_base64: this.mixin.tip_key_base64,
                  session_private_key: this.mixin.session_seed
                }
              });
              offset = new Date(created_at).toISOString();
              offset = offset.substring(0, offset.length - 1);
              offset = offset + '000000Z';
              _context0.n = 2;
              return user.safe.fetchSafeSnapshots({
                asset: asset_id,
                limit: 500,
                offset: offset
              });
            case 2:
              snapshots = _context0.v;
              if (callback) {
                callback(snapshots);
              }
              return _context0.a(2, snapshots);
            case 3:
              _context0.p = 3;
              _t5 = _context0.v;
              console.error('ERROR: Mixin error fetch safe snapshots: ' + _t5);
              if (callback) {
                callback(false);
              }
              return _context0.a(2, false);
          }
        }, _callee0, this, [[1, 3]]);
      }));
      function fetchSafeSnapshots(_x0) {
        return _fetchSafeSnapshots.apply(this, arguments);
      }
      return fetchSafeSnapshots;
    }()
    /**
    * "data": [
      {
          "deposit_id": "UUID-DEPOSIT",
          "destination": "ADDRESS",
          "tag": "TAG",
          "chain_id": "CHAIN-UUID",
          "asset_id": "ASSET-UUID",
          "asset_key": "CHAIN-ASSET-KEY",
          "amount": "NUMBER",
          "transaction_hash": "BLOCKCHAIN-SPECIFIC-HASH",
          "output_index": 0,
          "block_hash": "BLOCKCHAIN-SPECIFIC-HASH",
          "block_number": 333333,
          "confirmations": 5,
          "threshold": 10,
          "state": "pending or confirmed",
          "created_at": "RFC3339NANO",
          "updated_at": "RFC3339NANO"
      }
    ]
    */
  }, {
    key: "fetchPendingDeposits",
    value: function () {
      var _fetchPendingDeposits = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(asset_id, destination, callback) {
        var user, params, deposits, _t6;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              _context1.p = 0;
              if (destination) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2, callback([]));
            case 1:
              user = MixinApi({
                keystore: {
                  app_id: this.mixin.user_id,
                  session_id: this.mixin.session_id,
                  pin_token_base64: this.mixin.tip_key_base64,
                  session_private_key: this.mixin.session_seed
                }
              });
              params = {
                asset: asset_id,
                destination: destination
              };
              _context1.n = 2;
              return user.safe.pendingDeposits(params);
            case 2:
              deposits = _context1.v;
              return _context1.a(2, callback(deposits));
            case 3:
              _context1.p = 3;
              _t6 = _context1.v;
              console.error('ERROR: Mixin error fetch fetchPendingDeposits: ' + _t6);
              return _context1.a(2, false);
          }
        }, _callee1, this, [[0, 3]]);
      }));
      function fetchPendingDeposits(_x1, _x10, _x11) {
        return _fetchPendingDeposits.apply(this, arguments);
      }
      return fetchPendingDeposits;
    }() // Custom function to play nicely with BuySaito ... can't fck with callbacks
  }, {
    key: "consolidatedLookUp",
    value: function () {
      var _consolidatedLookUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(ticker, destination, created_at, keys) {
        var asset_id, _iterator2, _step2, cm, user, params, deposits, utxo, offset, snapshots;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              // Note to self: if we ever support duplicate tickers on different chains
              // (with different asset ids..), will need to fix a lot of things
              _iterator2 = _createForOfIteratorHelper(this.crypto_mods);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  cm = _step2.value;
                  if (cm.ticker == ticker) {
                    asset_id = cm.asset_id;
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              user = MixinApi({
                keystore: {
                  app_id: keys.user_id,
                  session_id: keys.session_id,
                  pin_token_base64: keys.tip_key_base64,
                  session_private_key: keys.session_seed
                }
              });
              params = {
                asset: asset_id,
                destination: destination
              };
              _context10.n = 1;
              return user.safe.pendingDeposits(params);
            case 1:
              deposits = _context10.v;
              _context10.n = 2;
              return user.utxo.safeAssetBalance({
                members: [keys.user_id],
                threshold: 1,
                asset: asset_id
              });
            case 2:
              utxo = _context10.v;
              offset = new Date(created_at).toISOString();
              offset = offset.substring(0, offset.length - 1);
              offset = offset + '000000Z';
              _context10.n = 3;
              return user.safe.fetchSafeSnapshots({
                asset: asset_id,
                limit: 100,
                offset: offset
              });
            case 3:
              snapshots = _context10.v;
              return _context10.a(2, {
                deposits: deposits,
                utxo: utxo,
                snapshots: snapshots
              });
          }
        }, _callee10, this);
      }));
      function consolidatedLookUp(_x12, _x13, _x14, _x15) {
        return _consolidatedLookUp.apply(this, arguments);
      }
      return consolidatedLookUp;
    }()
  }, {
    key: "fetchUtxo",
    value: function () {
      var _fetchUtxo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var state,
          limit,
          order,
          callback,
          user,
          params,
          utxo_list,
          _args11 = arguments,
          _t7;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              state = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : 'unspent';
              limit = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : 100000;
              order = _args11.length > 2 && _args11[2] !== undefined ? _args11[2] : 'DESC';
              callback = _args11.length > 3 && _args11[3] !== undefined ? _args11[3] : null;
              _context11.p = 1;
              user = MixinApi({
                keystore: {
                  app_id: this.mixin.user_id,
                  session_id: this.mixin.session_id,
                  pin_token_base64: this.mixin.tip_key_base64,
                  session_private_key: this.mixin.session_seed
                }
              });
              params = {
                limit: limit,
                state: state,
                order: order
              };
              _context11.n = 2;
              return user.utxo.safeOutputs(params);
            case 2:
              utxo_list = _context11.v;
              console.log("utxo_list ".concat(state, ":///"), utxo_list);
              if (!callback) {
                _context11.n = 3;
                break;
              }
              return _context11.a(2, callback(utxo_list));
            case 3:
              _context11.n = 5;
              break;
            case 4:
              _context11.p = 4;
              _t7 = _context11.v;
              console.error('ERROR: Mixin error return utxo: ' + _t7);
              return _context11.a(2, false);
            case 5:
              return _context11.a(2);
          }
        }, _callee11, this, [[1, 4]]);
      }));
      function fetchUtxo() {
        return _fetchUtxo.apply(this, arguments);
      }
      return fetchUtxo;
    }()
  }, {
    key: "returnMixinNetworkInfo",
    value: function () {
      var _returnMixinNetworkInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(asset_id) {
        var user, asset, _t8;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              _context12.p = 0;
              user = MixinApi({
                keystore: {
                  app_id: this.mixin.user_id,
                  session_id: this.mixin.session_id,
                  pin_token_base64: this.mixin.tip_key_base64,
                  session_private_key: this.mixin.session_seed
                }
              });
              _context12.n = 1;
              return user.network.fetchAsset(asset_id);
            case 1:
              asset = _context12.v;
              return _context12.a(2, asset);
            case 2:
              _context12.p = 2;
              _t8 = _context12.v;
              console.error('ERROR: Mixin error check network fee: ' + _t8);
              return _context12.a(2, false);
          }
        }, _callee12, this, [[0, 2]]);
      }));
      function returnMixinNetworkInfo(_x16) {
        return _returnMixinNetworkInfo.apply(this, arguments);
      }
      return returnMixinNetworkInfo;
    }()
  }, {
    key: "returnWithdrawalFee",
    value: function () {
      var _returnWithdrawalFee = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(asset_id, recipient) {
        var user, asset, chain, feeResponse, fee, feeAsset, _t9, _t0, _t1, _t10;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.p = _context13.n) {
            case 0:
              _context13.p = 0;
              user = MixinApi({
                keystore: {
                  app_id: this.mixin.user_id,
                  session_id: this.mixin.session_id,
                  pin_token_base64: this.mixin.tip_key_base64,
                  session_private_key: this.mixin.session_seed
                }
              });
              _context13.n = 1;
              return user.safe.fetchAsset(asset_id);
            case 1:
              asset = _context13.v;
              if (!(asset.chain_id === asset.asset_id)) {
                _context13.n = 2;
                break;
              }
              _t9 = asset;
              _context13.n = 4;
              break;
            case 2:
              _context13.n = 3;
              return user.safe.fetchAsset(asset.chain_id);
            case 3:
              _t9 = _context13.v;
            case 4:
              chain = _t9;
              _context13.n = 5;
              return user.safe.fetchFee(asset.asset_id, recipient);
            case 5:
              feeResponse = _context13.v;
              fee = selectWithdrawalFee(feeResponse, asset.asset_id, chain.asset_id);
              if (!(!(fee !== null && fee !== void 0 && fee.asset_id) || fee.amount == null)) {
                _context13.n = 6;
                break;
              }
              throw new Error("No withdrawal fee available for ".concat(asset_id));
            case 6:
              if (!(fee.asset_id === asset.asset_id)) {
                _context13.n = 7;
                break;
              }
              _t0 = asset;
              _context13.n = 11;
              break;
            case 7:
              if (!(fee.asset_id === chain.asset_id)) {
                _context13.n = 8;
                break;
              }
              _t1 = chain;
              _context13.n = 10;
              break;
            case 8:
              _context13.n = 9;
              return user.safe.fetchAsset(fee.asset_id);
            case 9:
              _t1 = _context13.v;
            case 10:
              _t0 = _t1;
            case 11:
              feeAsset = _t0;
              return _context13.a(2, _objectSpread(_objectSpread({}, fee), {}, {
                ticker: feeAsset.display_symbol || feeAsset.symbol
              }));
            case 12:
              _context13.p = 12;
              _t10 = _context13.v;
              console.error('ERROR: Mixin error check withdrawl fee: ' + _t10);
              return _context13.a(2, false);
          }
        }, _callee13, this, [[0, 12]]);
      }));
      function returnWithdrawalFee(_x17, _x18) {
        return _returnWithdrawalFee.apply(this, arguments);
      }
      return returnWithdrawalFee;
    }()
  }, {
    key: "sendInNetworkTransferRequest",
    value: function () {
      var _sendInNetworkTransferRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(asset_id, destination, amount) {
        var memo,
          alt_keys,
          _createMixinCredentia2,
          keystore,
          spend_private_key,
          user_id,
          client,
          members,
          threshold,
          recipients,
          outputs,
          balance,
          _getUnspentOutputsFor,
          utxos,
          change,
          request_id,
          ghosts,
          tx,
          raw,
          verifiedTx,
          signedRaw,
          sendedTx,
          message,
          _args14 = arguments,
          _t11,
          _t12;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.p = _context14.n) {
            case 0:
              memo = _args14.length > 3 && _args14[3] !== undefined ? _args14[3] : '';
              alt_keys = _args14.length > 4 && _args14[4] !== undefined ? _args14[4] : null;
              _context14.p = 1;
              // Preserve the existing alternate-account call signature used by BuySaito.
              if (memo && _typeof(memo) === 'object' && !Buffer.isBuffer(memo)) {
                alt_keys = memo;
                memo = '';
              }
              _createMixinCredentia2 = createMixinCredentials(alt_keys || this.mixin), keystore = _createMixinCredentia2.keystore, spend_private_key = _createMixinCredentia2.spend_private_key, user_id = _createMixinCredentia2.user_id;
              client = MixinApi({
                keystore: keystore
              }); // destination
              members = [destination];
              threshold = 1;
              recipients = [buildSafeTransactionRecipient(members, threshold, amount)]; // get unspent utxos
              _context14.n = 2;
              return client.utxo.safeOutputs({
                members: [user_id],
                threshold: 1,
                asset: asset_id,
                state: 'unspent'
              });
            case 2:
              outputs = _context14.v;
              console.log('outputs: ', outputs);
              _context14.n = 3;
              return client.utxo.safeAssetBalance({
                members: [user_id],
                threshold: 1,
                asset: asset_id,
                state: 'unspent'
              });
            case 3:
              balance = _context14.v;
              console.log('balance: ', balance);

              // Get utxo inputs and change fot tx
              _getUnspentOutputsFor = getUnspentOutputsForRecipients(outputs, recipients), utxos = _getUnspentOutputsFor.utxos, change = _getUnspentOutputsFor.change;
              if (!change.isZero() && !change.isNegative()) {
                recipients.push(buildSafeTransactionRecipient(outputs[0].receivers, outputs[0].receivers_threshold, change.toString()));
              }
              console.log('mixin checkpoint');
              request_id = v4();
              _context14.n = 4;
              return client.utxo.ghostKey(recipients, request_id, spend_private_key);
            case 4:
              ghosts = _context14.v;
              console.log('ghosts: ', ghosts);

              // build safe transaction raw
              tx = buildSafeTransaction(utxos, recipients, ghosts, createMixinMemo(memo));
              console.log('tx: ', tx);
              _context14.p = 5;
              raw = encodeSafeTransaction(tx);
              _context14.n = 7;
              break;
            case 6:
              _context14.p = 6;
              _t11 = _context14.v;
              throw new Error("Unable to encode Mixin Safe transaction (".concat(tx.inputs.length, " input(s), ").concat(tx.outputs.length, " output(s), asset ").concat(tx.asset, "): ").concat(formatMixinError(_t11)));
            case 7:
              console.log('raw: ', raw);

              // verify safe transaction
              _context14.n = 8;
              return client.utxo.verifyTransaction([{
                raw: raw,
                request_id: request_id
              }]);
            case 8:
              verifiedTx = _context14.v;
              console.log('verifiedTx: ', verifiedTx);

              // sign safe transaction with the private key registerd to safe
              signedRaw = signSafeTransaction(tx, verifiedTx[0].views, spend_private_key);
              console.log('signedRaw:', signedRaw);
              _context14.n = 9;
              return client.utxo.sendTransactions([{
                raw: signedRaw,
                request_id: request_id
              }]);
            case 9:
              sendedTx = _context14.v;
              console.log('sendedTx: ', sendedTx);
              return _context14.a(2, {
                status: 200,
                message: sendedTx,
                pending_balance: calculatePendingBalance(balance, amount)
              });
            case 10:
              _context14.p = 10;
              _t12 = _context14.v;
              message = formatMixinError(_t12);
              console.error('Mixin internal transfer failed:', message);
              return _context14.a(2, {
                status: 400,
                message: message
              });
          }
        }, _callee14, this, [[5, 6], [1, 10]]);
      }));
      function sendInNetworkTransferRequest(_x19, _x20, _x21) {
        return _sendInNetworkTransferRequest.apply(this, arguments);
      }
      return sendInNetworkTransferRequest;
    }()
  }, {
    key: "sendExternalNetworkTransferRequest",
    value: function () {
      var _sendExternalNetworkTransferRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(asset_id, destination, amount) {
        var memo,
          _this$crypto_mods$fin,
          _this$crypto_mods$fin2,
          _createMixinCredentia3,
          keystore,
          spend_private_key,
          user_id,
          user,
          balance,
          asset,
          chain,
          feeResponse,
          fee,
          assetTicker,
          feeAsset,
          feeTicker,
          assetRequired,
          outputs,
          feeOutputs,
          feeBalance,
          recipients,
          _getUnspentOutputsFor2,
          utxos,
          change,
          txId,
          ghosts,
          tx,
          raw,
          ref,
          feeRecipients,
          _getUnspentOutputsFor3,
          feeUtxos,
          feeChange,
          feeId,
          feeGhosts,
          feeTx,
          feeRaw,
          txs,
          signedRaw,
          signedFeeRaw,
          res,
          _outputs,
          _recipients,
          _getUnspentOutputsFor4,
          _utxos,
          _change,
          request_id,
          _ghosts,
          _tx,
          _raw,
          _txs,
          _signedRaw,
          _res,
          message,
          _args15 = arguments,
          _t13,
          _t14,
          _t15,
          _t16;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.p = _context15.n) {
            case 0:
              memo = _args15.length > 3 && _args15[3] !== undefined ? _args15[3] : '';
              _context15.p = 1;
              _createMixinCredentia3 = createMixinCredentials(this.mixin), keystore = _createMixinCredentia3.keystore, spend_private_key = _createMixinCredentia3.spend_private_key, user_id = _createMixinCredentia3.user_id;
              user = MixinApi({
                keystore: keystore
              });
              _context15.n = 2;
              return user.utxo.safeAssetBalance({
                members: [user_id],
                threshold: 1,
                asset: asset_id,
                state: 'unspent'
              });
            case 2:
              balance = _context15.v;
              _context15.n = 3;
              return user.safe.fetchAsset(asset_id);
            case 3:
              asset = _context15.v;
              if (!(asset.chain_id === asset.asset_id)) {
                _context15.n = 4;
                break;
              }
              _t13 = asset;
              _context15.n = 6;
              break;
            case 4:
              _context15.n = 5;
              return user.safe.fetchAsset(asset.chain_id);
            case 5:
              _t13 = _context15.v;
            case 6:
              chain = _t13;
              _context15.n = 7;
              return user.safe.fetchFee(asset.asset_id, destination);
            case 7:
              feeResponse = _context15.v;
              fee = selectWithdrawalFee(feeResponse, asset.asset_id, chain.asset_id);
              if (!(!(fee !== null && fee !== void 0 && fee.asset_id) || fee.amount == null)) {
                _context15.n = 8;
                break;
              }
              throw new Error("No withdrawal fee available for ".concat(asset_id));
            case 8:
              assetTicker = ((_this$crypto_mods$fin = this.crypto_mods.find(function (crypto_module) {
                return crypto_module.asset_id === asset.asset_id;
              })) === null || _this$crypto_mods$fin === void 0 ? void 0 : _this$crypto_mods$fin.ticker) || asset.display_symbol || asset.symbol;
              if (!(fee.asset_id === asset.asset_id)) {
                _context15.n = 9;
                break;
              }
              _t14 = asset;
              _context15.n = 13;
              break;
            case 9:
              if (!(fee.asset_id === chain.asset_id)) {
                _context15.n = 10;
                break;
              }
              _t15 = chain;
              _context15.n = 12;
              break;
            case 10:
              _context15.n = 11;
              return user.safe.fetchAsset(fee.asset_id);
            case 11:
              _t15 = _context15.v;
            case 12:
              _t14 = _t15;
            case 13:
              feeAsset = _t14;
              feeTicker = ((_this$crypto_mods$fin2 = this.crypto_mods.find(function (crypto_module) {
                return crypto_module.asset_id === fee.asset_id;
              })) === null || _this$crypto_mods$fin2 === void 0 ? void 0 : _this$crypto_mods$fin2.ticker) || feeAsset.display_symbol || feeAsset.symbol;
              assetRequired = new Decimal(amount).plus(fee.asset_id === asset.asset_id ? fee.amount : 0);
              if (!new Decimal(balance).lessThan(assetRequired)) {
                _context15.n = 14;
                break;
              }
              throw new Error("Insufficient ".concat(assetTicker, " balance: ").concat(assetRequired.toString(), " required, ").concat(balance, " available."));
            case 14:
              console.log('fee', fee);
              console.log('balance: ', balance);

              // withdrawal with chain asset as fee
              if (!(fee.asset_id !== asset.asset_id)) {
                _context15.n = 23;
                break;
              }
              _context15.n = 15;
              return user.utxo.safeOutputs({
                asset: asset_id,
                state: 'unspent'
              });
            case 15:
              outputs = _context15.v;
              _context15.n = 16;
              return user.utxo.safeOutputs({
                asset: fee.asset_id,
                state: 'unspent'
              });
            case 16:
              feeOutputs = _context15.v;
              _context15.n = 17;
              return user.utxo.safeAssetBalance({
                members: [user_id],
                threshold: 1,
                asset: fee.asset_id,
                state: 'unspent'
              });
            case 17:
              feeBalance = _context15.v;
              if (!new Decimal(feeBalance).lessThan(fee.amount)) {
                _context15.n = 18;
                break;
              }
              throw new Error("A ".concat(feeTicker, " balance is required to withdraw ").concat(assetTicker, ". ") + "The network fee is ".concat(fee.amount, " ").concat(feeTicker, ", but only ").concat(feeBalance, " ").concat(feeTicker, " is available."));
            case 18:
              console.log('outputs: ', outputs, 'feeOutputs: ', feeOutputs);
              recipients = [
              // withdrawal output, must be put first
              {
                amount: amount,
                destination: destination
              }];
              _getUnspentOutputsFor2 = getUnspentOutputsForRecipients(outputs, recipients), utxos = _getUnspentOutputsFor2.utxos, change = _getUnspentOutputsFor2.change;
              if (!change.isZero() && !change.isNegative()) {
                // add change output if needed
                recipients.push(buildSafeTransactionRecipient(outputs[0].receivers, outputs[0].receivers_threshold, change.toString()));
              }

              // get ghost key to send tx
              txId = v4();
              _context15.n = 19;
              return user.utxo.ghostKey(recipients, txId, spend_private_key);
            case 19:
              ghosts = _context15.v;
              // ghostKey already leaves the withdrawal entry undefined and index-aligned.
              tx = buildSafeTransaction(utxos, recipients, ghosts, createMixinMemo(memo));
              console.log('tx: ', tx);
              raw = encodeSafeTransaction(tx);
              ref = blake3Hash(Buffer.from(raw, 'hex')).toString('hex');
              feeRecipients = [
              // fee output
              buildSafeTransactionRecipient([MixinCashier], 1, fee.amount)];
              _getUnspentOutputsFor3 = getUnspentOutputsForRecipients(feeOutputs, feeRecipients), feeUtxos = _getUnspentOutputsFor3.utxos, feeChange = _getUnspentOutputsFor3.change;
              if (!feeChange.isZero() && !feeChange.isNegative()) {
                // add fee change output if needed
                feeRecipients.push(buildSafeTransactionRecipient(feeOutputs[0].receivers, feeOutputs[0].receivers_threshold, feeChange.toString()));
              }
              feeId = v4();
              _context15.n = 20;
              return user.utxo.ghostKey(feeRecipients, feeId, spend_private_key);
            case 20:
              feeGhosts = _context15.v;
              feeTx = buildSafeTransaction(feeUtxos, feeRecipients, feeGhosts, createMixinMemo(), [ref]);
              console.log('feeTx: ', feeTx);
              feeRaw = encodeSafeTransaction(feeTx);
              console.log('feeRaw: ', feeRaw);

              //console.log(txId, feeId);
              _context15.n = 21;
              return user.utxo.verifyTransaction([{
                raw: raw,
                request_id: txId
              }, {
                raw: feeRaw,
                request_id: feeId
              }]);
            case 21:
              txs = _context15.v;
              signedRaw = signSafeTransaction(tx, txs[0].views, spend_private_key);
              signedFeeRaw = signSafeTransaction(feeTx, txs[1].views, spend_private_key);
              _context15.n = 22;
              return user.utxo.sendTransactions([{
                raw: signedRaw,
                request_id: txId
              }, {
                raw: signedFeeRaw,
                request_id: feeId
              }]);
            case 22:
              res = _context15.v;
              console.log('res: ', res);
              return _context15.a(2, {
                status: 200,
                message: res,
                pending_balance: calculatePendingBalance(balance, amount)
              });
            case 23:
              _context15.n = 24;
              return user.utxo.safeOutputs({
                asset: asset_id,
                state: 'unspent'
              });
            case 24:
              _outputs = _context15.v;
              console.log('outputs: ', _outputs);
              _recipients = [
              // withdrawal output, must be put first
              {
                amount: amount,
                destination: destination
              },
              // fee output
              buildSafeTransactionRecipient([MixinCashier], 1, fee.amount)];
              _getUnspentOutputsFor4 = getUnspentOutputsForRecipients(_outputs, _recipients), _utxos = _getUnspentOutputsFor4.utxos, _change = _getUnspentOutputsFor4.change;
              if (!_change.isZero() && !_change.isNegative()) {
                // add change output if needed
                _recipients.push(buildSafeTransactionRecipient(_outputs[0].receivers, _outputs[0].receivers_threshold, _change.toString()));
              }
              console.log('mixin checkpoint');
              request_id = v4();
              _context15.n = 25;
              return user.utxo.ghostKey(_recipients, request_id, spend_private_key);
            case 25:
              _ghosts = _context15.v;
              _tx = buildSafeTransaction(_utxos, _recipients, _ghosts, createMixinMemo(memo));
              console.log('tx: ', _tx);
              _raw = encodeSafeTransaction(_tx);
              console.log(request_id);
              _context15.n = 26;
              return user.utxo.verifyTransaction([{
                raw: _raw,
                request_id: request_id
              }]);
            case 26:
              _txs = _context15.v;
              _signedRaw = signSafeTransaction(_tx, _txs[0].views, spend_private_key);
              _context15.n = 27;
              return user.utxo.sendTransactions([{
                raw: _signedRaw,
                request_id: request_id
              }]);
            case 27:
              _res = _context15.v;
              console.log('res: ', _res);
              return _context15.a(2, {
                status: 200,
                message: _res,
                pending_balance: calculatePendingBalance(balance, amount, fee.amount)
              });
            case 28:
              _context15.n = 30;
              break;
            case 29:
              _context15.p = 29;
              _t16 = _context15.v;
              message = formatMixinError(_t16);
              console.error('Mixin external transfer failed:', message);
              return _context15.a(2, {
                status: 400,
                message: message
              });
            case 30:
              return _context15.a(2);
          }
        }, _callee15, this, [[1, 29]]);
      }));
      function sendExternalNetworkTransferRequest(_x22, _x23, _x24) {
        return _sendExternalNetworkTransferRequest.apply(this, arguments);
      }
      return sendExternalNetworkTransferRequest;
    }()
    /**
     *
     * TODO -- we want a uniqueness constraint so we don't make duplicate entries
     * everytime a user ports their key and "recovers" their mixin credentials
     */
  }, {
    key: "receiveSaveUserTransaction",
    value: function () {
      var _receiveSaveUserTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(app, tx, peer, callback) {
        var message, user_id, address, publickey, asset_id, created_at, updated_at, sql, params, result;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              message = tx.returnMessage();
              user_id = message.data.user_id;
              address = message.data.address;
              publickey = message.data.publickey;
              asset_id = message.data.asset_id;
              created_at = tx.timestamp;
              updated_at = tx.timestamp;
              sql = "INSERT INTO mixin_users (user_id,\n        address,\n        publickey,\n        asset_id,\n        created_at,\n        updated_at)\n      VALUES ($user_id,\n        $address,\n        $publickey,\n        $asset_id,\n        $created_at,\n        $updated_at\n    )";
              params = {
                $user_id: user_id,
                $address: address,
                $publickey: publickey,
                $asset_id: asset_id,
                $created_at: created_at,
                $updated_at: updated_at
              };
              _context16.n = 1;
              return this.app.storage.runDatabase(sql, params, 'mixin');
            case 1:
              result = _context16.v;
              console.log(result);
              if (!callback) {
                _context16.n = 2;
                break;
              }
              return _context16.a(2, callback(result));
            case 2:
              return _context16.a(2);
          }
        }, _callee16, this);
      }));
      function receiveSaveUserTransaction(_x25, _x26, _x27, _x28) {
        return _receiveSaveUserTransaction.apply(this, arguments);
      }
      return receiveSaveUserTransaction;
    }()
  }, {
    key: "backupMixinAccount",
    value: function () {
      var _backupMixinAccount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(data, pkey) {
        var delete_first,
          sql2,
          params2,
          r,
          sql,
          params,
          result,
          _args17 = arguments;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              delete_first = _args17.length > 2 && _args17[2] !== undefined ? _args17[2] : false;
              if (!delete_first) {
                _context17.n = 2;
                break;
              }
              sql2 = "DELETE FROM mixin_accounts WHERE publickey = $publickey";
              params2 = {
                $publickey: pkey
              };
              _context17.n = 1;
              return this.app.storage.runDatabase(sql2, params2, 'mixin');
            case 1:
              r = _context17.v;
              console.log("Mixin cleanup for ".concat(pkey, ": "), r);
            case 2:
              sql = "INSERT INTO mixin_accounts (publickey, account_hash) VALUES ($publickey, $account_hash)";
              params = {
                $publickey: pkey,
                $account_hash: data
              };
              _context17.n = 3;
              return this.app.storage.runDatabase(sql, params, 'mixin');
            case 3:
              result = _context17.v;
              return _context17.a(2, result);
          }
        }, _callee17, this);
      }));
      function backupMixinAccount(_x29, _x30) {
        return _backupMixinAccount.apply(this, arguments);
      }
      return backupMixinAccount;
    }()
  }, {
    key: "restoreMixinAccount",
    value: function () {
      var _restoreMixinAccount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(pkey) {
        var sql, params, result;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.n) {
            case 0:
              sql = "SELECT * FROM mixin_accounts WHERE publickey = $publickey";
              params = {
                $publickey: pkey
              };
              _context18.n = 1;
              return this.app.storage.queryDatabase(sql, params, 'mixin');
            case 1:
              result = _context18.v;
              return _context18.a(2, result);
          }
        }, _callee18, this);
      }));
      function restoreMixinAccount(_x31) {
        return _restoreMixinAccount.apply(this, arguments);
      }
      return restoreMixinAccount;
    }()
  }, {
    key: "sendFetchUserTransaction",
    value: function () {
      var _sendFetchUserTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19() {
        var _this$mixin_peer2;
        var params,
          callback,
          _args19 = arguments;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.n) {
            case 0:
              params = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : {};
              callback = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : null;
              return _context19.a(2, this.app.network.sendRequestAsTransaction('mixin fetch user', params, function (res) {
                console.log('Callback for sendFetchUser: ', params, res);
                if (callback) {
                  callback(res);
                }
                return res;
              }, (_this$mixin_peer2 = this.mixin_peer) === null || _this$mixin_peer2 === void 0 ? void 0 : _this$mixin_peer2.publicKey));
          }
        }, _callee19, this);
      }));
      function sendFetchUserTransaction() {
        return _sendFetchUserTransaction.apply(this, arguments);
      }
      return sendFetchUserTransaction;
    }()
  }, {
    key: "receiveFetchUserTransaction",
    value: function () {
      var _receiveFetchUserTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(app, tx, peer) {
        var callback,
          data,
          filters,
          params,
          sql,
          result,
          _args20 = arguments,
          _t17;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.p = _context20.n) {
            case 0:
              callback = _args20.length > 3 && _args20[3] !== undefined ? _args20[3] : null;
              data = tx.returnMessage().data;
              filters = [];
              params = {};
              if (data !== null && data !== void 0 && data.asset_id) {
                _context20.n = 1;
                break;
              }
              return _context20.a(2, callback === null || callback === void 0 ? void 0 : callback([]));
            case 1:
              if (data !== null && data !== void 0 && data.address) {
                filters.push('address = $address');
                params['$address'] = data.address;
              }
              if (data !== null && data !== void 0 && data.publicKey) {
                filters.push('publickey = $publickey');
                params['$publickey'] = data.publicKey;
              }
              if (data !== null && data !== void 0 && data.user_id) {
                filters.push('user_id = $user_id');
                params['$user_id'] = data.user_id;
              }
              if (filters.length) {
                _context20.n = 2;
                break;
              }
              return _context20.a(2, callback === null || callback === void 0 ? void 0 : callback([]));
            case 2:
              filters.push('asset_id = $asset_id');
              params['$asset_id'] = data.asset_id;
              sql = "SELECT * FROM mixin_users WHERE ".concat(filters.join(' AND '), " ORDER BY created_at DESC");
              console.log('*****', sql, params);
              _context20.p = 3;
              _context20.n = 4;
              return this.app.storage.queryDatabase(sql, params, 'mixin');
            case 4:
              result = _context20.v;
              return _context20.a(2, callback === null || callback === void 0 ? void 0 : callback(result));
            case 5:
              _context20.p = 5;
              _t17 = _context20.v;
              console.error(_t17);
              return _context20.a(2, callback === null || callback === void 0 ? void 0 : callback([]));
          }
        }, _callee20, this, [[3, 5]]);
      }));
      function receiveFetchUserTransaction(_x32, _x33, _x34) {
        return _receiveFetchUserTransaction.apply(this, arguments);
      }
      return receiveFetchUserTransaction;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21() {
        var _this$app;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.n) {
            case 0:
              if (!((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.options) !== null && _this$app !== void 0 && _this$app.mixin)) {
                _context21.n = 2;
                break;
              }
              console.log('USING SAVED MIXIN USER ACCOUNT');
              this.mixin = this.app.options.mixin;
              if (!this.mixin.user_id) {
                _context21.n = 2;
                break;
              }
              this.account_created = 1;

              //check if legacy user
              if (!(typeof this.mixin.pin_token_base64 != 'undefined')) {
                _context21.n = 2;
                break;
              }
              _context21.n = 1;
              return this.saveLegacy();
            case 1:
              this.account_created = 0;
              this.mixin = {};
              this.save();
              _context21.n = 2;
              return this.app.wallet.setPreferredCrypto('SAITO', 1);
            case 2:
              return _context21.a(2);
          }
        }, _callee21, this);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "save",
    value: function save() {
      this.app.options.mixin = this.mixin;
      this.app.storage.saveOptions();
    }
  }, {
    key: "saveLegacy",
    value: function () {
      var _saveLegacy = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22() {
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.n) {
            case 0:
              this.app.options.mixin_legacy = this.mixin;
              this.app.storage.saveOptions();
            case 1:
              return _context22.a(2);
          }
        }, _callee22, this);
      }));
      function saveLegacy() {
        return _saveLegacy.apply(this, arguments);
      }
      return saveLegacy;
    }()
  }]);
}(ModTemplate);
module.exports = Mixin;